import SortIcon from "../../../global/components/SortIcon";
import {
  formatUnixTime,
  formatUTCTime,
} from "../../../global/utils/unixToLocalTime";
export const DeviceColumns = (setParams, params, columnsValues) => {
  const modParams = { ...Object.fromEntries([...params?.entries()]) } || {}; //

  const isColumnVisible = (columnKey) => {
    return columnsValues?.includes(columnKey);
  };

  function shortenListWithDots(input) {
    const parts = input.split(",").map((s) => s.trim());
    if (parts.length <= 2) return input; // No need to shorten if 2 or fewer items
    return `${parts.slice(0, 2).join(", ")}, ...`;
  }
  return [
    // {
    //   title: "",
    //   dataIndex: "",
    //   width: 20,
    // },
    {
      title: "No",
      dataIndex: "LogNo",
      key: "LogNo",
      hidden: !isColumnVisible("LogNo"),
      width: 80,
      sorter: (a, b) => () => {},
      sortIcon: () => (
        <SortIcon
          sortOrder={modParams.order}
          columnKey="LogNo"
          sortBy={modParams.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...modParams,
            sort_by: "LogNo",
            order: modParams.order === "desc" ? "asc" : "desc",
          })),
      }),
    },
    {
      title: "Log Time",
      dataIndex: "LogTime",
      key: "LogTime",
      width: 150,
      hidden: !isColumnVisible("LogTime"),
      render: (text) => <div>{text ? formatUTCTime(text) : ""}</div>,
      sorter: (a, b) => () => {},
      sortIcon: () => (
        <SortIcon
          sortOrder={modParams.order}
          columnKey="LogTime"
          sortBy={modParams.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...modParams,
            sort_by: "LogTime",
            order: modParams.order === "desc" ? "asc" : "desc",
          })),
      }),
    },
    {
      title: "Account Name",
      dataIndex: "Account",
      key: "Account",
      width: 150,
      hidden: !isColumnVisible("Account"),
      render: (text) => <div>{text}</div>,
      sorter: (a, b) => () => {},
      sortIcon: () => (
        <SortIcon
          sortOrder={modParams.order}
          columnKey="AccountNo"
          sortBy={modParams.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...modParams,
            sort_by: "AccountNo",
            order: modParams.order === "desc" ? "asc" : "desc",
          })),
      }),
    },
    {
      title: "Device Name",
      dataIndex: "DeviceName",
      key: "DeviceName",
      width: 150,
      hidden: !isColumnVisible("DeviceName"),
      render: (text) => <div>{text}</div>,
      sorter: (a, b) => () => {},
      sortIcon: () => (
        <SortIcon
          sortOrder={modParams.order}
          columnKey="DeviceNo"
          sortBy={modParams.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...modParams,
            sort_by: "DeviceNo",
            order: modParams.order === "desc" ? "asc" : "desc",
          })),
      }),
    },
    // {
    //   title: "Production",
    //   dataIndex: "Production",
    //   key: "Production",
    //   render: (text) => <div>{text}</div>,
    //   sorter: (a, b) => () => {},
    //   sortIcon: () => (
    //     <SortIcon
    //       sortOrder={modParams.order}
    //       columnKey="ProductionNo"
    //       sortBy={modParams.sort_by}
    //     />
    //   ),
    //   onHeaderCell: () => ({
    //     onClick: () =>
    //       setParams((prev) => ({
    //         ...modParams,
    //         sort_by: "ProductionNo",
    //         order: modParams.order === "desc" ? "asc" : "desc",
    //       })),
    //   }),
    // },
    {
      title: "OEM",
      dataIndex: "Oem",
      key: "Oem",
      width: 150,
      hidden: !isColumnVisible("Oem"),
      render: (text) => <div>{text}</div>,
      sorter: (a, b) => () => {},
      sortIcon: () => (
        <SortIcon
          sortOrder={modParams.order}
          columnKey="OemNo"
          sortBy={modParams.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...modParams,
            sort_by: "OemNo",
            order: modParams.order === "desc" ? "asc" : "desc",
          })),
      }),
    },
    {
      title: "Dealer",
      dataIndex: "Dealer",
      key: "Dealer",
      width: 150,
      hidden: !isColumnVisible("Dealer"),
      render: (text) => <div>{text}</div>,
      sorter: (a, b) => () => {},
      sortIcon: () => (
        <SortIcon
          sortOrder={modParams.order}
          columnKey="DealerNo"
          sortBy={modParams.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...modParams,
            sort_by: "DealerNo",
            order: modParams.order === "desc" ? "asc" : "desc",
          })),
      }),
    },
    {
      title: "Customer",
      dataIndex: "Customer",
      key: "Customer",
      hidden: !isColumnVisible("Customer"),
      width: 150,
      sorter: (a, b) => a?.CustomerName?.length - b?.CustomerName?.length,
      sortIcon: () => (
        <SortIcon
          sortOrder={modParams.order}
          columnKey="CustomerNo"
          sortBy={modParams.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...modParams,
            sort_by: "CustomerNo",
            order: modParams.order === "desc" ? "asc" : "desc",
          })),
      }),
    },
    {
      title: "Node Type",
      dataIndex: "NodeType",
      key: "NodeType",
      width: 120,
      hidden: !isColumnVisible("NodeType"),
      sorter: (a, b) => a?.NodeType?.length - b?.NodeType?.length,
      sortIcon: () => (
        <SortIcon
          sortOrder={modParams.order}
          columnKey="NodeType"
          sortBy={modParams.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...modParams,
            sort_by: "NodeType",
            order: modParams.order === "desc" ? "asc" : "desc",
          })),
      }),
    },
    {
      title: "Site Type",
      dataIndex: "SiteType",
      key: "SiteType",
      width: 120,
      hidden: !isColumnVisible("SiteType"),
      sorter: (a, b) => () => {},
      sortIcon: () => (
        <SortIcon
          sortOrder={modParams.order}
          columnKey="SiteType"
          sortBy={modParams.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...modParams,
            sort_by: "SiteType",
            order: modParams.order === "desc" ? "asc" : "desc",
          })),
      }),
    },
    // {
    //   title: "Account",
    //   dataIndex: "AccountNo",
    //   key: "AccountNo",
    //   sorter: (a, b) => a?.AccountNo?.length - b?.AccountNo?.length,
    //   sortIcon: () => (
    //     <SortIcon
    //       sortOrder={params.order}
    //       columnKey="AccountNo"
    //       sortBy={params.sort_by}
    //     />
    //   ),
    //   onHeaderCell: () => ({
    //     onClick: () =>
    //       setParams((prev) => ({
    //         ...prev,
    //         sort_by: "AccountNo",
    //         order: prev.order === "desc" ? "asc" : "desc",
    //       })),
    //   }),
    // },
    {
      title: "MAC",
      dataIndex: "Mac",
      key: "Mac",
      width: 120,
      hidden: !isColumnVisible("Mac"),
      sorter: (a, b) => () => {},
      sortIcon: () => (
        <SortIcon
          sortOrder={modParams.order}
          columnKey="Mac"
          sortBy={modParams.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...modParams,
            sort_by: "Mac",
            order: modParams.order === "desc" ? "asc" : "desc",
          })),
      }),
    },
    {
      title: "Product",
      dataIndex: "Product",
      key: "Product",
      width: 120,
      hidden: !isColumnVisible("Product"),
      sorter: (a, b) => () => {},
      sortIcon: () => (
        <SortIcon
          sortOrder={modParams.order}
          columnKey="Product"
          sortBy={modParams.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...modParams,
            sort_by: "Product",
            order: modParams.order === "desc" ? "asc" : "desc",
          })),
      }),
    },
    {
      title: "Model",
      dataIndex: "Model",
      key: "Model",
      width: 120,
      hidden: !isColumnVisible("Model"),
      sorter: (a, b) => () => {},
      sortIcon: () => (
        <SortIcon
          sortOrder={modParams.order}
          columnKey="Model"
          sortBy={modParams.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...modParams,
            sort_by: "Model",
            order: modParams.order === "desc" ? "asc" : "desc",
          })),
      }),
    },
    {
      title: "Door",
      dataIndex: "Type",
      key: "Type",
      width: 120,
      hidden: !isColumnVisible("Type"),
      sorter: (a, b) => () => {},
      sortIcon: () => (
        <SortIcon
          sortOrder={modParams.order}
          columnKey="Type"
          sortBy={modParams.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...modParams,
            sort_by: "Type",
            order: modParams.order === "desc" ? "asc" : "desc",
          })),
      }),
    },

    // {
    //   title: "License Options",
    //   dataIndex: "Options",
    //   key: "Options",
    //   width: 150,
    //   hidden: !isColumnVisible("Options"),
    //   sorter: (a, b) => () => {},
    //   sortIcon: () => (
    //     <SortIcon
    //       sortOrder={modParams.order}
    //       columnKey="Options"
    //       sortBy={modParams.sort_by}
    //     />
    //   ),
    //   onHeaderCell: () => ({
    //     onClick: () =>
    //       setParams((prev) => ({
    //         ...modParams,
    //         sort_by: "Options",
    //         order: modParams.order === "desc" ? "asc" : "desc",
    //       })),
    //   }),
    //   render: (text) => {
    //     return text?.length > 0 ? shortenListWithDots(text) : "";
    //   },
    // },
    // {
    //   title: "License Devices",
    //   dataIndex: "Devices",
    //   key: "Devices",
    //   width: 150,
    //   hidden: !isColumnVisible("Devices"),
    //   // sorter: (a, b) => () => {},
    //   // sortIcon: () => (
    //   //   <SortIcon
    //   //     sortOrder={modParams.order}
    //   //     columnKey="Devices"
    //   //     sortBy={modParams.sort_by}
    //   //   />
    //   // ),
    //   // onHeaderCell: () => ({
    //   //   onClick: () =>
    //   //     setParams((prev) => ({
    //   //       ...modParams,
    //   //       sort_by: "Devices",
    //   //       order: modParams.order === "desc" ? "asc" : "desc",
    //   //     })),
    //   // }),
    //   render: (text) => {
    //     return text?.length > 0 ? shortenListWithDots(text) : "";
    //   },
    // },
    {
      title: "",
      dataIndex: "",
      key: "",
      width: 1,
    },
    // {
    //   title: "Type",
    //   dataIndex: "Type",
    //   key: "Type",
    //   sorter: (a, b) => a?.Type?.length - b?.Type?.length,
    //   sortIcon: () => (
    //     <SortIcon
    //       sortOrder={params.order}
    //       columnKey="Type"
    //       sortBy={params.sort_by}
    //     />
    //   ),
    //   onHeaderCell: () => ({
    //     onClick: () =>
    //       setParams((prev) => ({
    //         ...prev,
    //         sort_by: "Type",
    //         order: prev.order === "desc" ? "asc" : "desc",
    //       })),
    //   }),
    // },
    // {
    //   title: "OEM",
    //   dataIndex: "OemName",
    //   key: "OemName",
    //   sorter: (a, b) => a?.OemName?.length - b?.OemName?.length,
    //   sortIcon: () => (
    //     <SortIcon
    //       sortOrder={params.order}
    //       columnKey="OemName"
    //       sortBy={params.sort_by}
    //     />
    //   ),
    //   onHeaderCell: () => ({
    //     onClick: () =>
    //       setParams((prev) => ({
    //         ...prev,
    //         sort_by: "OemNo",
    //         order: prev.order === "desc" ? "asc" : "desc",
    //       })),
    //   }),
    // },
    // {
    //   title: "Dealer",
    //   dataIndex: "DealerName",
    //   key: "DealerName",
    //   sorter: (a, b) => a?.DealerName?.length - b?.DealerName?.length,
    //   sortIcon: () => (
    //     <SortIcon
    //       sortOrder={params.order}
    //       columnKey="DealerName"
    //       sortBy={params.sort_by}
    //     />
    //   ),
    //   onHeaderCell: () => ({
    //     onClick: () =>
    //       setParams((prev) => ({
    //         ...prev,
    //         sort_by: "DealerNo",
    //         order: prev.order === "desc" ? "asc" : "desc",
    //       })),
    //   }),
    // },
    // {
    //   title: "Customer",
    //   dataIndex: "CustomerName",
    //   key: "CustomerName",
    //   sorter: (a, b) => a?.CustomerName?.length - b?.CustomerName?.length,
    //   sortIcon: () => (
    //     <SortIcon
    //       sortOrder={params.order}
    //       columnKey="CustomerName"
    //       sortBy={params.sort_by}
    //     />
    //   ),
    //   onHeaderCell: () => ({
    //     onClick: () =>
    //       setParams((prev) => ({
    //         ...prev,
    //         sort_by: "CustomerNo",
    //         order: prev.order === "desc" ? "asc" : "desc",
    //       })),
    //   }),
    // },
    // {
    //   title: "Expired",
    //   dataIndex: "Expired",
    //   key: "Expired",
    //   sorter: (a, b) => a?.Expired?.length - b?.Expired?.length,
    //   sortIcon: () => (
    //     <SortIcon
    //       sortOrder={params.order}
    //       columnKey="Expired"
    //       sortBy={params.sort_by}
    //     />
    //   ),
    //   onHeaderCell: () => ({
    //     onClick: () =>
    //       setParams((prev) => ({
    //         ...prev,
    //         sort_by: "Expired",
    //         order: prev.order === "desc" ? "asc" : "desc",
    //       })),
    //   }),
    // },
    // {
    //   title: "",
    //   fixed: "right",
    //   width: 0,
    //   align: "center",
    // },
  ];
};
